export default __webpack_public_path__ + "static/media/i102jp.31d282ae.webp";